import { FormLoja } from '@/models'
import { removerCaracteresEspeciaisDeTexto } from '../formatadores'
import { substituirDiasDeDevolucao, tipoDePagamentoTemRecorrencia } from '../loja-shareds'
import { IdDaSecao } from './secoes'

export interface ProblemaAoSalvar {
	secao: IdDaSecao
	mensagem: string
}

/** As mesmas conferências do salvar da tela antiga, na mesma ordem, dizendo a seção que precisa de ajuste. */
export function validarLojaAntesDeSalvar(loja: FormLoja): ProblemaAoSalvar | null {
	if (!loja.telefones || loja.telefones.length === 0) {
		return { secao: 'endereco', mensagem: 'Informe ao menos um telefone' }
	}
	if (loja.grupoEconomico && loja.grupoEconomico.id === '') {
		return { secao: 'dados', mensagem: 'Informe um grupo econômico' }
	}
	const problemaDoNps = validarOrdemDoNps(loja)
	if (problemaDoNps) return { secao: 'nps', mensagem: problemaDoNps }

	const configuracao = loja.configuracaoDaLoja
	if (configuracao.sintaxeBoxlink !== '' && configuracao.sintaxeBoxlink !== null) {
		if (configuracao.tamanhoEtiquetaBoxlink === null || configuracao.tamanhoEtiquetaBoxlink === '') {
			return { secao: 'pedidos', mensagem: 'Configure um tamanho para a etiqueta BoxLink' }
		}
		if (configuracao.tokenBoxlink === null || configuracao.tokenBoxlink === '') {
			return { secao: 'pedidos', mensagem: 'Configure o token para a etiqueta BoxLink' }
		}
	}
	return null
}

function validarOrdemDoNps(loja: FormLoja): string | null {
	const perguntas = loja.avaliacaoNpsConfig || []
	if (!loja.configuracaoDaLoja.utilizarAvaliacaoNps || !perguntas.length) return null

	const ordens = perguntas.map(({ ordem }) => ordem)
	if (ordens.some(ordem => !ordem || ordem <= 0)) {
		return 'Todas as perguntas de NPS devem ter uma ordem maior ou igual a 1.'
	}
	if (new Set(ordens).size !== ordens.length) {
		return 'A ordem das perguntas de NPS não pode ter números repetidos.'
	}
	const emSequencia = [...ordens].sort((a, b) => a - b).every((ordem, indice) => ordem === indice + 1)
	return emSequencia
		? null
		: 'A ordem das perguntas de NPS deve ser uma sequência contínua a partir de 1 (ex.: 1, 2, 3).'
}

/** O que vai para a API: as mesmas transformações que a tela antiga faz no salvar. */
export function montarLojaParaSalvar(loja: FormLoja): FormLoja {
	const { politicaDeTrocaTexto, diasParaDevolucao } = loja.configuracaoDaLoja
	return {
		...loja,
		razaoSocial: removerCaracteresEspeciaisDeTexto(loja.razaoSocial),
		tiposDePagamento: loja.tiposDePagamento.map(tipoDePagamento =>
			tipoDePagamentoTemRecorrencia(tipoDePagamento)
				? tipoDePagamento
				: { ...tipoDePagamento, diasDeRecorrencia: 0 },
		),
		configuracaoDaLoja: {
			...loja.configuracaoDaLoja,
			codigoCSRT: loja.configuracaoDaLoja.codigoCSRT?.trim() || null,
			politicaDeTrocaTexto: politicaDeTrocaTexto
				? substituirDiasDeDevolucao(politicaDeTrocaTexto, diasParaDevolucao)
				: politicaDeTrocaTexto,
		},
	}
}
